import { withStyles, WithStyles } from "@mui/styles";
import colorsStyle from "assets/jss/mui-extras/colorsStyle";
import classNames from "classnames";
import * as React from "react";

export type MuiColors =
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | "notice"
    | "muted"
    | "mutedDark"
    | "mutedLight"
    | "white"
    | "black"
    | "inherit"
    | "transparent";

export interface MuiColorsProps {
    className?: string;
    title?: string;
    variant: MuiColors,
    component?: "span" | "div";
}

type Props = MuiColorsProps & WithStyles<typeof colorsStyle>;

const MuiColor: React.FC<Props> = (props) => {
    const { classes, className, variant, component, children, title } = props;

    const localClasses = classNames({
        [classes[variant]]: variant != null,
        [className]: className !== undefined
    });

    return variant == null
        ? (<>{children}</>)
        : component == "span"
            ? <span className={localClasses} title={title}>{children}</span>
            : <div className={localClasses} title={title}>{children}</div>;
};

MuiColor.defaultProps = {
    component: "span"
};

export default withStyles(colorsStyle)(MuiColor);